import { ResultModal } from './ResultModal';

export default ResultModal;
